<div fxFlex [fxLayoutAlign]="wrapperLayoutAlign" fxLayoutGap="25px">

  <div fxFlex>
    <form [formGroup]="form"> 
      <mat-form-field class="width-100">
        <input 
          matInput
          #provinceInput
          formControlName="province" 
          [matAutocomplete]="provinceAC" 
          [placeholder]="'LABEL_PROVINCE' | translate"
          (focus)="!provinceAC.isOpen && getInitialValues('province')" 
          (blur)="checkAutocompleteObject(form, 'province')"
          [required]="isRequired"
          >

        <mat-icon 
          id="id_select_province_delete_btn"
          matSuffix 
          color="primary"
          class="clear-input"
          svgIcon="close-circle"
          (click)="provinceInput.blur(); clearForm($event)"
          *ngIf="provinceInput.value && !disabled"
          >
        </mat-icon>

        <mat-icon 
          matSuffix 
          class="clear-input"
          svgIcon="menu-down"
          *ngIf="!provinceInput.value && !disabled"
          >
        </mat-icon>

        <mat-autocomplete 
          id="id_select_province_dropdown"
          [displayWith]="displayFn" 
          #provinceAC="matAutocomplete" 
          (closed)="autoCmpltClosed(); provinceInput.blur()"
          (opened)="autocompleteScroll('province','provinceACRef','provinceACTr')"
          >
          <mat-option
            disabled
            *ngIf="!loading.province && listData?.length == 0"
            >
            {{ 'LABEL_NO_DATA' | translate }}
          </mat-option>

          <mat-option
            [id]="'id_select_province_data_' + (i+1)"
            [value]="data" 
            matTooltipPosition="right"
            *ngFor="let data of listData; let i = index" 
            [matTooltip]="data.code + ' - ' + data.description"
            >
            {{ data.code }} - {{ data.description }}
          </mat-option>

          <mat-option *ngIf="loading.province" disabled>
            <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
          </mat-option>
        </mat-autocomplete>

        <mat-error *ngIf="form.get('province').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>

        <mat-error *ngIf="form.get('province').hasError('notExisting')">
          {{ 'MSG_DOESNT_EXIST' | translate: {type: 'LABEL_PROVINCE' | translate} }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  
</div>